import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/home',
            title: 'Karageorgos Dimitris',
            canonical: 'https://www.karageorgos-dimitris.com/',
            metaTags: [
                {
                    name: 'description',
                    content: `I'm a software engineer with 6+ years of experience`
                },
                {
                    property: 'og:title',
                    content: 'Karageorgos Dimitris'
                }
            ]
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/components/Home'),
            meta: {
                title: 'Karageorgos Dimitris',
                canonical: 'https://www.karageorgos-dimitris.com/',
                metaTags: [
                    {
                        name: 'description',
                        content: `I'm a software engineer with 6+ years of experience`
                    },
                    {
                        property: 'og:title',
                        content: 'Karageorgos Dimitris'
                    }
                ]
            }
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('@/components/About')
        },
        {
            path: '/technologies',
            name: 'technologies',
            component: () => import('@/components/Technologies')
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('@/components/Contact')
        }
    ]
})

router.beforeEach((to, from, next) => {
    next()
})

export default router
